export enum AppPreviewActions {
    UPDATE_PURCHASE_STEP1_DATA = 'appPreview/UPDATE_PURCHASE_STEP1_DATA',
    UPDATE_IG_REELS_STEP1_DATA = 'appPreview/UPDATE_IG_REELS_STEP_DATA',
    UPDATE_IG_STORY_REPOST_STEP1_DATA = 'appPreview/UPDATE_IG_STORY_REPOST_STEP1_DATA',
    UPDATE_TIKTOK_REPOST_STEP1_DATA = 'appPreview/UPDATE_TIKTOK_REPOST_STEP1_DATA',
    UPDATE_TIKTOK_STEP1_DATA = 'appPreview/UPDATE_TIKTOK_STEP1_DATA',
    UPDATE_TIKTOK_PLACEHOLDER_DATA = 'appPreview/UPDATE_TIKTOK_PLACEHOLDER_DATA',
    UPDATE_IG_POST_STEP1_DATA = 'appPreview/UPDATE_IG_POST_STEP1_DATA',
    UPDATE_IG_POST_PLACEHOLDER_DATA = 'appPreview/UPDATE_IG_POST_PLACEHOLDER_DATA',
    CLEAR_APP_PREVIEW_DATA = 'appPreview/CLEAR_APP_PREVIEW_DATA',
    UPDATE_IG_REELS_PLACEHOLDER_DATA = 'appPreview/UPDATE_IG_REELS_PLACEHOLDER_DATA',
    UPDATE_PURCHASE_PLACEHOLDER_DATA = 'appPreview/UPDATE_PURCHASE_PLACEHOLDER_DATA',
    UPDATE_IG_STORY_NON_UGC_STEP1_DATA = 'appPreview/UPDATE_IG_STORY_NON_UGC_STEP_DATA',
    UPDATE_IG_STORY_NON_UGC_PLACEHOLDER_DATA = 'appPreview/UPDATE_IG_STORY_NON_UGC_PLACEHOLDER_DATA',
    UPDATE_IG_STORY_UGC_STEP1_DATA = 'appPreview/UPDATE_IG_STORY_UGC_STEP_DATA',
    UPDATE_IG_STORY_UGC_PLACEHOLDER_DATA = 'appPreview/UPDATE_IG_STORY_UGC_PLACEHOLDER_DATA',
    UPDATE_REVIEW_TEXT_IMAGE_STEP1_DATA = 'appPreview/UPDATE_REVIEW_TEXT_IMAGE_STEP1_DATA',
    UPDATE_REVIEW_TEXT_IMAGE_PLACEHOLDER_DATA = 'appPreview/UPDATE_REVIEW_TEXT_IMAGE_PLACEHOLDER_DATA',
    UPDATE_DOWNLOAD_APP_STEP1_DATA = 'appPreview/UPDATE_DOWNLOAD_APP_STEP1_DATA',
    UPDATE_DOWNLOAD_APP_PLACEHOLDER_DATA = 'appPreview/UPDATE_DOWNLOAD_APP_PLACEHOLDER_DATA',
    UPDATE_FOLLOW_STEP1_DATA = 'appPreview/UPDATE_FOLLOW_STEP1_DATA',
    UPDATE_FOLLOW_PLACEHOLDER_DATA = 'appPreview/UPDATE_FOLLOW_PLACEHOLDER_DATA',
    UPDATE_VIDEO_CREATION_STEP1_DATA = 'appPreview/UPDATE_VIDEO_CREATION_STEP1_DATA',
    UPDATE_VIDEO_CREATION_PLACEHOLDER_DATA = 'appPreview/UPDATE_VIDEO_CREATION_PLACEHOLDER_DATA',
    UPDATE_PHOTO_CREATION_STEP1_DATA = 'appPreview/UPDATE_PHOTO_CREATION_STEP1_DATA',
    UPDATE_PHOTO_CREATION_PLACEHOLDER_DATA = 'appPreview/UPDATE_PHOTO_CREATION_PLACEHOLDER_DATA',
}

export const clearAppPreviewData = () => ({
    type: AppPreviewActions.CLEAR_APP_PREVIEW_DATA,
})
